export default __webpack_public_path__ + "static/media/team-photo-2009.3b7dbf8c.jpg";